// extracted by mini-css-extract-plugin
module.exports = {"content":"tab-medical-information_content__1x62c"};